import { createDeliveryClient } from "@kontent-ai/delivery-sdk";

const environmentId = process.env.REACT_APP_DELIVERY_ID || "";
const previewApiKey = process.env.REACT_APP_DELIVERY_PREVIEW_TOKEN || "";

const deliveryClient = createDeliveryClient({
  environmentId,
  previewApiKey,
  defaultQueryConfig: {
    usePreviewMode: process.env.REACT_APP_ENV !== "prod",
  },
});

export const getContentItem = async (
  contentTag,
  culture = process.env.REACT_APP_DEFAULT_CULTURE
) => {
  try {
    const { data } = await deliveryClient
      .item(contentTag)
      .languageParameter(culture)
      .toPromise();

    return data;
  } catch (error) {
    console.error("[KontentService] Error fetching content item:", error);
    throw error;
  }
};
